import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/**
 * Usa `navigator.userAgentData.platform` (Chromium)
 * e cai no `userAgent` nos demais navegadores.
 */
export function isMac() {
    const nav = globalThis.navigator as
        | (Navigator & { userAgentData?: { platform?: string } })
        | undefined

    return /mac/i.test(nav?.userAgentData?.platform || nav?.userAgent || '')
}

/**
 * Formata número no padrão pt-BR (ponto para milhar, vírgula para decimal).
 * Todo número apresentado ao usuário deve passar por aqui.
 */
export function formatarNumero(value: number | string | null | undefined) {
    const numero = typeof value === 'string' ? Number(value) : value

    if (numero === null || numero === undefined || Number.isNaN(numero)) {
        return ''
    }

    return numero.toLocaleString('pt-BR')
}

/**
 * Formata um valor em centavos como moeda BRL (R$ 1.234,56).
 */
export function formatarMoeda(centavos: number | null | undefined) {
    if (centavos == null) return ''

    return (centavos / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })
}
